<template>

  	<div class="shopcart-wrap">
		<cartHeader :isProCart="isProCart" 
			:isEdite = "isEdite"
			v-on:editeToggle = "editeToggle"
		></cartHeader>
		
		<div v-if="!loading">
			<div class="default-panel" v-if="shopCartList.length == 0">
				<p class="empty">当前购物车暂无商品</p>
			</div>
			<div class="default-panel" v-else>
				
				<!-- 可购买配件商品列表 start-->
				<shopCartComList
					:partList 				= 'purPartList'
					:proChecked 			= 'proChecked'
					v-on:delCartItem 		= 'delCartItem'
					v-on:subCheckedToggle 	= 'subCheckedToggle'
					v-on:updateNum 			= 'updateNum'
					v-on:birthPopup 		= 'birthPopup'
					v-on:undateGreetingCard = 'undateGreetingCard'

				></shopCartComList>
				<!-- 可购买配件商品列表 end-->
				

				<!-- 配件列表 start-->
				<shopCartPartList
					:isEdite 				= 'isEdite'
					:partList				= 'shopCartPartList'
					:proChecked 			= 'proChecked'
					:isPurPartChecked 		= 'isPurPartChecked'
					v-on:delCartItem 		= 'delCartItem'
					v-on:subCheckedToggle 	= 'subCheckedToggle'
					v-on:updateNum 			= 'updateNum'

				></shopCartPartList>
				<!-- 配件列表 end-->

				<!-- 配件选择列表 为true时显示start-->
				<productPart 
				v-if="purPartList.length>0"
				></productPart> 
				<!-- 配件选择列表 end-->

				<!-- 不可购买配件商品列表 start-->
				<shopCartComList
					:isEdite 				= 'isEdite'
					:partList 				= 'unPurPartList'
					:proChecked 			= 'proChecked'
					v-on:delCartItem 		= 'delCartItem'
					v-on:subCheckedToggle 	= 'subCheckedToggle'
					v-on:updateNum 			= 'updateNum'
					v-on:birthPopup 		= 'birthPopup'
					v-on:undateGreetingCard = 'undateGreetingCard'

				></shopCartComList>
				<!-- 不可购买配件商品列表 end-->


				<!-- 已下架 start-->
				<shopCartNoSaleList
					:isEdite					='isEdite'
					:partList 				= 'noSaleList'
					:proChecked 			= 'proChecked'
					v-on:delCartItem 		= 'delCartItem'
					v-on:subCheckedToggle 	= 'subCheckedToggle'
					v-on:updateNum 			= 'updateNum'
				></shopCartNoSaleList>
				<!-- 已下架 end-->

			</div>
			
			<div class="car-bottom-sec" :class="{'bottom': isProCart}" v-if="shopCartList.length > 0">
				<div class="car-bottom-content">
					<div class="car-bottom-left">
						<div class="checkbox-group-content">
							<span class="checkbox-group">
								<input type="checkbox" class="input-checkbox" value="true" v-model="checkedAll" @change="checkedAllToggle">
								<span class="icon-checkbox"></span>
							</span>全选
						</div>
						<span v-show="!isEdite">
							合计：
							<span class="text-red">¥{{finalOrderPrice | filterPrice}}</span>
							<span class="text-grey">含运费</span>
						</span>
					</div>
					<span class="checkout-btn" :class="{'disabled':checkedNum==0}" @click="deleteChooseItem" v-if="isEdite">
						删除所选<span v-if="checkedNum>0">({{checkedNum}})</span>
					</span>
					<span class="checkout-btn" :class="{'disabled':checkedNum==0}" @click="ckeckout" v-else>
						下单结算<span v-if="checkedNum>0">({{checkedNum}})</span>
					</span>
				</div>
			</div>
		</div>
		
		<mt-popup
			class="birth-wrap"
		  	v-model="popupVisible"
		  	position="right">
		  <birthBrand
		  	v-on:birthShow = 'birthPopupToggle'
		  	v-on:saveBirthText = 'getBirthText'
		  ></birthBrand>	
		</mt-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	
	import { MessageBox } from '@/js/mint-ui'
	import { CellSwipe } from '@/js/mint-ui';
  	import { Toast } from '@/js/mint-ui';
	Vue.component(CellSwipe.name, CellSwipe);
	import { Popup } from '@/js/mint-ui';
	Vue.component(Popup.name, Popup);


	import cartHeader from './shoppingCartHeader'
	import birthBrand from './birthBrand'
	import counter from '../counter'
	import productPart from './productPart'

	import shopCartPartList from './shopCartPartList'
	import shopCartComList from './shopCartComList'
	import shopCartNoSaleList from './shopCartNoSaleList'

	import mainNavBar from '@/components/common/mainNavBar'

	import { mapState,mapGetters } from 'vuex'

	export default {
		data(){
			return {
				loading: true,
				isEdite: false,//不否为编辑状态
				accesListShow: false,//显示配件
				popupVisible: false,
				// proChecked: [],//非编辑时选择的项
				isEditeChecked:[],//编辑时选择的项
				checkedAll: [],
				isProCart: false,//是否是从产品详情页进入
				checkedNum: 0,//已选产品数
				submitTrue: false,//是否点了下单结算
				currItem: '',//当前被操作记录,
			}
		},
		computed: {
		    router(){

		        if (this.isProCart ) {
		          return this.$route.fullPath + '?isProCart=true'
		        } else {
		          return this.$route.fullPath;
		        }

		    },
		  	path () {
		        return this.$route.query['url']
		    },
		    ...mapGetters([
				'purPartList', //可购买配件，但非配件商品
				'unPurPartList',//不可购买配件商品
				'shopCartPartList',//已加入购物车的配件
				'noSaleList',//已下架商品
				'tempCheckShopList', //除下架的以外人所有商品
				'isPurPartChecked'//是否有可选配件商品被选 择
		    ]),
			...mapState({
				shopCartList: state=> state.shopCart.shopCartList,
				partList: state => state.shopCart.partList,
				finalOrderPrice: state => state.shopCart.finalOrderPrice,
				freight: state => state.shopCart.freight,
				totalPrice: state => state.shopCart.totalPrice,
				proChecked: state=>{ ///非编辑时选择的项
					const { shopCartList  } = state.shopCart;
					let checkArr = [];
					shopCartList.map(function(item){
						if(item.checked && item.saleStatus == 2 ){
							checkArr.push(item.uniqueId);
						}
					});
					return checkArr || [];
				}
			})
		},
		components: {
			cartHeader,
			birthBrand,
			counter,
			mainNavBar,
			productPart,
			shopCartPartList,
			shopCartComList,
			shopCartNoSaleList
		},
		watch:{
			proChecked(val,oldVal){
				console.log('proChecked',val);
				let self = this;
				this.checkedNum = val.length;
				let curShopCartList = [];
				if(this.isEdite==true){
					curShopCartList = this.shopCartList

				}else {
					curShopCartList = this.tempCheckShopList
				}

				if(this.proChecked.length < curShopCartList.length){
					this.checkedAll = [];
				}else if(this.proChecked.length == curShopCartList.length){
					
					this.checkedAll[0] = true;
				}

				if(this.isEdite == false && curShopCartList.length == 0){
					this.checkedAll = [];
				}

			},

			isEdite(val){
				let self = this;
				if(val == true){
					let shopCartList = this.shopCartList;
					self.proChecked = [];
					shopCartList.map(function(item){
						if(!!item.checked){
							self.proChecked.push(item.uniqueId);
						}
						
					})

				}else {
					let shopCartList = this.tempCheckShopList;
					self.proChecked = [];
					shopCartList.map(function(item){
						if(!!item.checked){
							self.proChecked.push(item.uniqueId);
						}
					})

				}
			}
		},
		mounted(){
			let self = this;
			this.isProCart = this.$route.query.isProCart ? this.$route.query.isProCart: false;
			this.$store.dispatch('getCartInfo').then(function(){
				// self.initChecked();
				self.loading = false;
			});
			this.$on('checkOutEvent',self.checkOutEventHandle);

		},
		methods: {
			checkNumVail(value){
				let val = value;
				val = val.replace(/\，/g,',');
				let valArr = val.indexOf(',') && val.split(',');
				let reg = /^[1-9]\d{0,10}$/;
				let flag = false;
				for(let i = 0 ; i < valArr.length ; i++){
					if(reg.test(valArr[i]) && valArr[i]<10){
						flag = true;
					}else {
						flag = false;
						return false;
						break;
					}
				}
				return flag;
				
			},
			// initChecked(){
			// 	let checkArr = [];
			// 	this.shopCartList.map(function(item){
			// 		if(item.checked && item.saleStatus == 2 ){
			// 			checkArr.push(item.uniqueId);
			// 		}
			// 	});
			// 	this.proChecked =  checkArr;
			// },
			checkedToggle(event,item){
				let params = {
					shopCartCheckItems: []
				}
				params.shopCartCheckItems.push({
					goodsChannelId: item.goodsChannelId,
					skuId: item.skuId,
					checked: event.target.checked,
					uniqueId: item.uniqueId
				})
				this.$store.dispatch('updateCheckItem',params)
			},
			subCheckedToggle(event,item){
				let self = this;
				let isEdite = this.isEdite;
				
				const checked = event.target.checked;
				const { proChecked } = this;

				if(checked){
					this.proChecked.push(item.uniqueId)
				}else {
					proChecked.map((proItem,index)=>{
						if(proItem == item.uniqueId){
							proChecked.splice(index,1);
						}
					})
					this.proChecked = proChecked;
				}

				let params = {
					shopCartCheckItems: []
				}
				params.shopCartCheckItems.push({
					goodsChannelId: item.goodsChannelId,
					skuId: item.goodsType == 2 ? null :item.skuId,
					checked: checked,
					uniqueId: item.uniqueId
				})
				this.$store.dispatch('updateCheckItem',params)
			},
			checkedAllToggle(){//全选
				var self  = this;
				let isEdite = this.isEdite;

				self.$nextTick(function(){
					let shopCartList = self.shopCartList;
					let tempCheckShopList = self.tempCheckShopList;
					let len = shopCartList.length;
					let tLen = tempCheckShopList.length;

					if(isEdite == false && tLen == 0){
						self.checkedAll = [];
						return false;
					}

					if(self.checkedAll.length>0){
						self.proChecked = [];
						
						if(isEdite == false){
							tempCheckShopList.map((item,index)=>{
								self.proChecked.push(item.uniqueId)
							})
						}else {
							shopCartList.map((item,index)=>{
								self.proChecked.push(item.uniqueId)
							})
						}
					}
					
					let params = {
						shopCartCheckItems: []
					};
					const { proChecked } = self;
					shopCartList.map((item,index)=>{
						proChecked.map((uniqueId,checkedIndex)=>{
							if(item.uniqueId == uniqueId){
								params.shopCartCheckItems.push({
									goodsChannelId: item.goodsChannelId,
									skuId: item.skuId,
									checked: self.checkedAll[0] ? true : false,
									uniqueId: item.uniqueId,
								})
							}
						})
						
					})
					console.log('params',params);
					console.log('proChecked',self.proChecked);

					self.$store.dispatch('updateCheckItem',params).then(function(res){
						
						if(self.checkedAll.length<=0){
							self.proChecked=[];
						}
					})
				})
				
			},
			birthPopup(item){//
				this.currItem = item;
				this.birthPopupToggle();
			},
			birthPopupToggle(){ //是否显示生日牌
				this.popupVisible = !this.popupVisible;
			},
			getBirthText(text){//修改生日牌
				let self = this;

				const { currItem } = this;
				let params = {
					goodsChannelId: currItem.goodsChannelId,
					birthdayCardContent: text,
					uniqueId: currItem.uniqueId,
					skuId: currItem.goodsType == 2 ? null :currItem.skuId
				}
				this.$store.dispatch('updateBirthText',params);
			},
			undateGreetingCard(event,item){ //修改祝福贺卡
				let self = this;
				const greetingCardText = event.target.value;
				let params = {
					goodsChannelId: item.goodsChannelId,
					greetingCardContent: greetingCardText,
					uniqueId: item.uniqueId,
					skuId:  item.goodsType == 2 ? null : item.skuId
				}

				self.$off('checkOutEvent');
				this.$store.dispatch('updateGreetingCard',params).then().then(()=>{
					self.$on('checkOutEvent',self.checkOutEventHandle);
					if(self.submitTrue){
						self.$emit('checkOutEvent');
					}
					self.submitTrue = false;
				});
			},
			updateNum(count,item,index){//数量修改
				let params = {
					goodsChannelId: item.goodsChannelId,					
					skuId: item.goodsType == 2 ? null : item.skuId,
					goodsNum: count,
					uniqueId: item.uniqueId
				}
				this.$store.dispatch('updateNum',params)
			},
			delCartItem(item){//删除商品
				var self  = this;
				MessageBox.confirm('','',{
					title: '',
					message: '是否确认删除',
					showCancelButton: true,
				}).then(function(action){
					
					let params = {
						goodsList: []
					}

					params.goodsList.push({
						goodsChannelId: item.goodsChannelId,
						skuId: item.goodsType == 2 ? null : item.skuId
					})

					console.log(params);

					self.$store.dispatch('delCartItem',params).then(function(){
						let proChecked = self.proChecked;
						self.proChecked = proChecked.filter((checkedItem)=>{
							return checkedItem != item.uniqueId
						});
						self.$store.dispatch('getCartInfo');
					})
				
				},function(action){
					console.log(action);

				})
			},
			ckeckout(){//下单结算
				// 下单结算，跳转微商城
				let cityInterceptList = [
                    "上海市",
                    "衡水市",
                    "抚顺市",
                    "南通市",
                    "海门市",
                    "盐城市",
                    "漳州市",
                    "漳浦县",
                    "南昌市",
                    "武汉市",
                    "郴州市",
                    "永兴县",
                    "佛山市",
                    "惠州市",
                    "昆明市",
                    "安宁市",
                    "广州市",
                    "深圳市",
                    "东莞市",
                    // 重庆下面的区
                    "重庆市",
                    "梁平县",
                    "两江新区",
                    "万州区",
                    "渝中区",
                    "大渡口区",
                    "江北区",
                    "沙坪坝区",
                    "九龙坡区",
                    "南岸区",
                    "北碚区",
                    "大足区",
                    "渝北区",
                    "巴南区",
                    "黔江区",
                    "合川区",
                    "南川区",
                    "璧山区",
                    "铜梁区",
                    "潼南县",
                    "城口县",
                    "丰都县",
                    "武隆县",
                    "忠县",
                    "开县",
                    "云阳县",
                    "奉节县",
                    "巫山县",
                    "巫溪县",
                    "石柱土家族自治县",
                    "秀山土家族苗族自治县",
                    "酉阳土家族苗族自治县",
                    "彭水苗族土家族自治县",
                    "开州区",
                    "垫江县",
                    "荣昌县",
                    "綦江区",
                    "涪陵区",
                    "永川区",
                    // 成都眉山地区20210113拦截
                    "眉山市",
                    "成都市",
                    "新津县",
                    // 20110118拦截
                    "温州市",
                    "合肥市",
                    "蚌埠市",
                    "芜湖市",
                    "无锡市",
                    "淮安市",
                    "泰安市",
                    "新泰市",
                    "济南市",
                    "南京市",
                    "中山市",
                    "揭阳市",
                    "揭西县",
                    "厦门市",
                    "柳州市",
                    "北海市",
                    "海口市",
                    "三亚市",
                    "东方市",
                    "东方市, 直辖县级",
                    "吉安市",
                    "萍乡市",
                    "抚州市",
                    "铜仁市",
                    "黔西南布依族苗族自治州",
                    "毕节市",
                    "兰州市",
                    "哈尔滨市",
                    "大连市",
                    "长春市",
                    "张家口市",
                    "滨海新区",
                    "秦皇岛市",
                    "银川市",
                    "唐山市",
                    "承德市",
                    "齐齐哈尔市",
                    "天津市",
                    "松滋市",
                    "咸宁市",
                    "潜江市",
                    "潜江市, 直辖县级",
                    "永城市",
                    "平顶山市",
                    "三门峡市",
                    "开封市",
                    "十堰市",
                    "孝感市",
                    "天门市",
                    "天门市, 直辖县级",
                    "武穴市",
                    "荥阳市",
                    "新郑市",
                    "中牟县",
                    "郑州市",
                    "荆州市",
                    "楚雄市",
                    "保山市",
                    "曲靖市",
                    "宣威市",
                    "攀枝花市",
                    // 四川省德阳市旌阳区
                    "旌阳区",
                    "绵阳市",
                    "西充县",
                    "达州市",
                    "遂宁市",
                    "拉萨市",
                    "泸州市",
                    "西安市",
                    "沧州市",
                    "汕头市",
                    // 20210126 城市拦截
                    "宁波市",
                    "衢州市",
                    "湖州市",
                    "舟山市",
                    "嘉兴市",
                    "海宁市",
                    "杭州市",
                    "绍兴市",
                    "金华市",
                    "义乌市",
                    "淮南市",
                    "宣城市",
                    "马鞍山市",
                    "苏州市",
                    "泰州市",
                    "连云港市",
                    "徐州市",
                    "常州市",
                    "德州市",
                    "潍坊市",
                    "滨州市",
                    "烟台市",
                    "威海市",
                    "青岛市",
                    "河源市",
                    "潮州市",
                    "信宜市",
                    "肇庆市",
                    "江门市",
                    "开平市",
                    "云浮市",
                    "茂名市",
                    "汕尾市",
                    "化州市",
                    "陆丰市",
                    "龙川县",
                    "鹤山市",
                    "凤岗镇",
                    "阳江市",
                    "怀集县",
                    "广宁县",
                    "高州市",
                    "珠海市",
                    "吴川市",
                    "湛江市",
                    "韶关市",
                    "清远市",
                    "梅州市",
                    "五华县",
                    "兴宁市",
                    "英德市",
                    "连州市",
                    "平潭县",
                    "福清市",
                    "南宁市",
                    "桂林市",
                    "百色市",
                    "玉林市",
                    "梧州市",
                    "上饶市",
                    "景德镇市",
                    "新余市",
                    "九江市",
                    "宜春市",
                    "赣州市",
                    "福州市",
                    "泉州市",
                    "莆田市",
                    "宁德市",
                    "贵阳市",
                    "遵义市",
                    "安顺市",
                    "六盘水市",
                    "乌鲁木齐市",
                    "西宁市",
                    "庆阳市",
                    "太原市",
                    "呼和浩特市",
                    "廊坊市",
                    "保定市",
                    "沈阳市",
                    "丹东市",
                    "永州市",
                    "公安县",
                    "荆门市",
                    "浏阳市",
                    "怀化市",
                    "株洲市",
                    "醴陵市",
                    "岳阳市",
                    "益阳市",
                    "商丘市",
                    "焦作市",
                    "南阳市",
                    "洛阳市",
                    "安阳市",
                    "新乡市",
                    "濮阳市",
                    "周口市",
                    "信阳市",
                    "随州市",
                    "襄阳市",
                    "恩施土家族苗族自治州",
                    "来凤县",
                    "利川市",
                    "湘西土家族苗族自治州",
                    "宜昌市",
                    "宜都市",
                    "常德市",
                    "安陆市",
                    "应城市",
                    "仙桃市",
                    "仙桃市, 直辖县级",
                    "邵阳市",
                    "衡阳市",
                    "娄底市",
                    "大冶市",
                    "黄石市",
                    "浠水县",
                    "蕲春县",
                    "鄂州市",
                    "黄冈市",
                    "武汉市",
                    "张家界市",
                    "桑植县",
                    "慈利县",
                    "大理白族自治州",
                    "内江市",
                    "宜宾市",
                    "荣昌县",
                    "南充市",
                    "自贡市",
                    "广安市",
                    "长寿区",
                    "玉溪市",
                    "江津区",
					"榆林市",
					 "台山市",
					"廉江市",
					"新丰县",
					"连南瑶族自治县",
					"罗源县",
					"南安市",
					"晋江市",
					"石狮市",
					"仙游县",
					"方中县",
                    "澧县",
                    "宁乡市, 长沙市",
                    "四会市",
					"中方县",
					"延安市",
					"渭南市",
                    "南部县",
                    "南部县, 南充市",
					"邯郸市",
					"海宁市, 嘉兴市",
					"义乌市, 金华市",
					"信宜市, 茂名市",
					"开平市, 江门市",
					"化州市, 茂名市",
					"陆丰市, 汕尾市",
					"龙川县, 河源市",
					"鹤山市, 江门市",
					"凤岗镇, 东莞市",
					"怀集县, 肇庆市",
					"广宁县, 肇庆市",
					"高州市, 茂名市",
					"吴川市, 湛江市",
					"五华县, 梅州市",
					"兴宁市, 梅州市",
					"英德市, 清远市",
					"连州市, 清远市",
					"平潭县, 福州市",
					"福清市, 福州市",
					"公安县, 荆州市",
					"浏阳市, 长沙市",
					"醴陵市, 株洲市",
					"来凤县, 恩施土家族苗族自治州",
					"利川市, 恩施土家族苗族自治州",
					"宜都市, 宜昌市",
					"安陆市, 孝感市",
					"应城市, 孝感市",
					"大冶市, 黄石市",
					"浠水县, 黄冈市",
					"蕲春县, 黄冈市",
					"桑植县, 张家界市",
					"慈利县, 张家界市",
					"长寿区, 重庆市",
					"江津区, 重庆市",
					"滨海新区, 天津市",
					"松滋市, 荆州市",
					"永城市, 商丘市",
					"武穴市, 黄冈市",
					"楚雄市, 楚雄彝族自治州",
					"涪陵区, 重庆市",
					"永川区, 重庆市",
					"西充县, 南充市",
					"石家庄市",
					"澳门半岛",
					/*20210223拦截*/
					"聊城市",
					"宁乡市",
					/*20210311拦截*/
                    "北京市",
                    /*20210322拦截*/
					"长沙市",
                    ];
				let locationCity = JSON.parse(localStorage.getItem('locationCity'));
                if(cityInterceptList.includes(locationCity.name) && locationCity.name){
                    location.href = 'https://m.xfxb.net/mall';
                    return
                }
				let self = this;
				this.submitTrue =  true;
				this.$emit('checkOutEvent');
			},
			deleteChooseItem(){
				var self = this;
				if(this.checkedNum <=0 ) return false;

				MessageBox.confirm('','',{
					title: '',
					message: '是否确认删除所选',
					showCancelButton: true,
				}).then(function(action){

					const { shopCartList,proChecked } = self;

					let params = {
						goodsList: []
					}

					shopCartList.map((cartItem,cartIndex)=>{
						proChecked.map((uniqueId,index)=>{
							if(uniqueId == cartItem.uniqueId){
								params.goodsList.push({
									goodsChannelId: cartItem.goodsChannelId,
									skuId: cartItem.skuId
								})
							}
						})
					})

					self.$store.dispatch('delCartItem',params).then(function(){
						self.proChecked = [];
						self.$store.dispatch('getCartInfo');
					})
				})
			},
			editeToggle(){//编辑完成按钮
				this.isEdite = !this.isEdite;
			},
			checkOutEventHandle(){
				let self  = this;
				let shopCartList = self.tempCheckShopList;
				let proChecked = self.proChecked;
				if(self.checkedNum <= 0) return false;

				let checkedAll = [];//当前选中商品
				let purChecked = [];//已选中商品里面的可选配件商品
				let unPurChecked = [];//不可选配件商品
				let partChecked=[];//配件商品


				shopCartList.map(function(sItem){
					proChecked.map(function(pItem){
						if( sItem.uniqueId == pItem){
							checkedAll.push(sItem)

							if(sItem.purchasableParts&&!sItem.parts){
								purChecked.push(sItem)
							}else if(!sItem.purchasableParts&&!sItem.parts){
								unPurChecked.push(sItem)
							}else if(sItem.parts) {
								partChecked.push(sItem)
							}
						}
					})
				})

				if(partChecked.length > 0 &&  purChecked.length<= 0){
					Toast('配件不能单独选择 ，请重新选择');
					return false;
				}

				let params = {
					goodsList: []
				}
				checkedAll.map((item,index)=>{
					if(item.goodsType == 2){
						params.goodsList.push({
							goodsChannelId: item.goodsChannelId,
							goodsNum: item.goodsNum
						})
					}else {
						params.goodsList.push({
							goodsChannelId: item.goodsChannelId,
							skuId: item.skuId,
							goodsNum: item.goodsNum
						})
					}
					
				})

				self.$store.dispatch('goOrder',params).then(function(){
					self.$router.push({
						path: '/firmOrder',
						query: {
							url:  self.isProCart ? '/productShoppingCart?isProCart=true' : '/shoppingCart'
						}
					})
				})

			}
		},
		
	}
</script>


<style lang="scss">	
@import '../../../assets/css/mixin';


.shopcart-wrap {
	padding-bottom: pxToRem(150px);
	.media .media-content .m-title .m-small {
		margin-top: pxToRem(10px);
	}
}

.grey-bg-sec {
	padding-bottom: pxToRem(20px);
	background-color: #eee;
}

.part-border {
	border: 1px solid #BDBDBD;
}



.part-table-footer {


	.part-mark {
		width: 100%;
    	text-align: right;
		border: none;
		// border: 1px solid #ccc;;
		// 
		// 
		&input::-webkit-input-placeholder {
			color: #666;
		} 
		

	}
	&.topBorder {
		border-top: 1px solid #eee;
	}
}

.cart-swiper {
	&:not(:first-of-type){
		margin-top: pxToRem(20px);
	}

	


	.pro-table-sec {
		width: 100%;
		background-color: #fff;
	}

	.pro-table {
		border-bottom: none;

	}

	.pro-table-footer {
		border-top: 1px solid #eee;
	}

	.mint-cell-wrapper {
		padding: 0;

		.mint-cell-title {
			display: none;
		}
		.mint-cell-value {
			width: 100%;
		}
	}

	.mint-cell-swipe-button {
		padding: 0;
		width: pxToRem(150px);
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center;
		font-size: pxToRem(24px);
	}
}

.car-bottom-sec {
	position: fixed;
	bottom: pxToRem(110px);
	left: 0;
	width: 100%;
	font-size: $defaultSize;
	border-top: 1px solid #eee;
	background-color: #fff;
	&.bottom {
		bottom: 0;
	}
	
	.car-bottom-content {
		display: flex;

		.car-bottom-left {
			padding: 0 pxToRem(20px) 0 pxToRem(40px);
			flex: 1;
			display: inline-flex;
			align-items: center;
			justify-content: space-between;

			.text-gray {
				margin-left: pxToRem(20px);
			}

		}
		.checkout-btn {
			width: pxToRem(230px);
			height: pxToRem(115px);
			line-height: pxToRem(115px);
			text-align: center;
			color: #fff;
			font-size: pxToRem(32px);
			background-color: #D8331D;
			&.disabled {
				background-color: #CCCCCC;
			}
		}
	}
}

.checkbox-group-content {
	display: flex;
    align-items: center;
}

.birth-wrap {
	width: 100%;
    height: 100%;
}

.empty{
	margin-top: pxToRem(102px);
	text-align: center;
	color: #666666;
}

.media-left {
	position: relative;
}

.isUnder {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(61,45,35,0.4);
	color: #FFFFFF;
	> span {
		display: flex;
		width: 100%;
		height: 100%;
		align-items: center;
		justify-content: center;
	}

}
</style>


// WEBPACK FOOTER //
// shoppingCart.vue?5e23b2f9